export default {
  badge: 'Jelvény',
  open: 'Megnyit',
  close: 'Bezárás',
  dismiss: 'Elutasít',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Mégsem',
  },
  dataIterator: {
    noResultsText: 'Nincs egyező találat',
    loadingText: 'Betöltés...',
  },
  dataTable: {
    itemsPerPageText: 'Elem oldalanként:',
    ariaLabel: {
      sortDescending: 'Csökkenő sorrendbe rendezve.',
      sortAscending: 'Növekvő sorrendbe rendezve.',
      sortNone: 'Rendezetlen.',
      activateNone: 'Rendezés törlése.',
      activateDescending: 'Aktiváld a csökkenő rendezésért.',
      activateAscending: 'Aktiváld a növekvő rendezésért.',
    },
    sortBy: 'Rendezés',
  },
  dataFooter: {
    itemsPerPageText: 'Elem oldalanként:',
    itemsPerPageAll: 'Mind',
    nextPage: 'Következő oldal',
    prevPage: 'Előző oldal',
    firstPage: 'Első oldal',
    lastPage: 'Utolsó oldal',
    pageText: '{0}-{1} / {2}',
  },
  dateRangeInput: {
    divider: '–',
  },
  datePicker: {
    itemsSelected: '{0} kiválasztva',
    range: {
      title: 'Válassza ki a dátumokat',
      header: 'Adja meg a dátumokat',
    },
    title: 'Válassza ki a dátumot',
    header: 'Adja meg a dátumot',
    input: {
      placeholder: 'Adja meg a dátumot',
    },
  },
  noDataText: 'Nincs elérhető adat',
  carousel: {
    prev: 'Előző',
    next: 'Következő',
    ariaLabel: {
      delimiter: 'Dia {0}/{1}',
    },
  },
  calendar: {
    moreEvents: '{0} további',
    today: 'Ma',
  },
  input: {
    clear: 'Törlés {0}',
    prependAction: '{0} előrehozott művelet',
    appendAction: '{0} hozzáadott művelet',
    otp: 'Kérjük, adja meg az OTP karaktert: {0}',
  },
  fileInput: {
    counter: '{0} fájl',
    counterSize: '{0} fájl ({1} összesen)',
  },
  fileUpload: {
    title: 'Húzza ide a fájlokat',
    divider: 'vagy',
    browse: 'Tallózás',
  },
  timePicker: {
    am: 'de',
    pm: 'du',
    title: 'Válassza ki az időpontot',
  },
  pagination: {
    ariaLabel: {
      root: 'Oldal navigáció',
      next: 'Következő oldal',
      previous: 'Előző oldal',
      page: 'Menj a(z) {0}. oldalra',
      currentPage: 'Aktuális oldal: {0}',
      first: 'Első oldal',
      last: 'Utolsó oldal',
    },
  },
  stepper: {
    next: 'Következő',
    prev: 'Előző',
  },
  rating: {
    ariaLabel: {
      item: 'Értékelés: {0} / {1}',
    },
  },
  loading: 'Betöltés...',
  infiniteScroll: {
    loadMore: 'Továbbiak betöltése',
    empty: 'Nincsen több',
  },
  rules: {
    required: 'Ez a mező kötelező',
    email: 'Kérlek, adj meg egy érvényes e-mail címet',
    number: 'Ez a mező csak számokat tartalmazhat',
    integer: 'Ez a mező csak egész számokat tartalmazhat',
    capital: 'Ez a mező csak nagybetűket tartalmazhat',
    maxLength: 'Maximum {0} karaktert adhatsz meg',
    minLength: 'Minimum {0} karaktert kell megadnod',
    strictLength: 'A megadott mező hossza érvénytelen',
    exclude: 'A(z) {0} karakter nem engedélyezett',
    notEmpty: 'Kérlek, válassz legalább egy értéket',
    pattern: 'Érvénytelen formátum',
  },
}
